import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from "react-redux";
import stores from './redux/stores.js';
import { PersistGate } from 'redux-persist/integration/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={stores.store}>
    <PersistGate loading={null} persistor={stores.persistor}>
    <Router>
      <App />
    </Router>
    </PersistGate>
  </Provider>
);
